import React, { useContext } from 'react';
import { getGiveawayAssets, GiveawayResponse } from '@oneaudi/avp-hck-dga-customerui-commons';
import { GiveawayContext } from '../../services/GiveawayContextService';
import { Gallery } from '../gallery/gallery';

export const Exterior = (): JSX.Element => {
  const giveawayResponse: GiveawayResponse = useContext(GiveawayContext);
  const { renderCameraFlight } = giveawayResponse;

  const assets: string[] = [
    ...getGiveawayAssets(giveawayResponse, 'exterior'),
    ...getGiveawayAssets(giveawayResponse, 'exterior-night'),
  ];

  return <Gallery assets={assets} name="exterior" titleSpacing={renderCameraFlight} />;
};
